import {makeStyles} from '@material-ui/core';

export const useStyles = makeStyles(theme => {
  return {
    breadcrumbsContainer: {
      position: 'sticky',
      zIndex: '1000',
      top: '64px',
      marginTop: '0',
      paddingLeft: '16px',
      marginLeft: '-20px',
      marginRight: '-20px',
    },
  };
});
